import { RegionShared } from "@1games-ru/region-shared";
import { InventoryItem } from "@1games-ru/region-shared/dist/types/inventory/inventory";
import { useCallback } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";
import { addInventoryItem, removeInventoryItem, reset } from "@/domains/inventory/slice";
import toast from "@/domains/toasts/helpers/toast";
import useConfiscationItems from "@/domains/inventory/hooks/search/useConfiscationItems";

export default function useSearchManager() {
  const dispatch = useAppDispatch();
  const { confiscationInventory } = useConfiscationItems();

  const addItemToConfiscation = useCallback(
    async (fromInventoryId: number, item: InventoryItem) => {
      if (!confiscationInventory) return;
      if (fromInventoryId !== confiscationInventory.id) {
        dispatch(
          addInventoryItem({
            inventoryId: confiscationInventory.id,
            inventoryItem: { ...item, inventoryId: confiscationInventory.id },
          }),
        );
      }
    },
    [],
  );

  const removeItemFromConfiscation = useCallback(
    async (fromInventoryId: number, toInventoryId: number, item: InventoryItem) => {
      if (!confiscationInventory) return;
      if (fromInventoryId !== toInventoryId && confiscationInventory.id === fromInventoryId) {
        dispatch(removeInventoryItem({ inventoryId: fromInventoryId, inventoryItemId: item.id }));
      }
    },
    [confiscationInventory],
  );

  const confiscate = useCallback(
    async (data: typeof RegionShared.Backend.Requests.InventoryConfiscationRequest) => {
      const response = await RpcMpProvider.getInstance().callServer<
        typeof RegionShared.Backend.Requests.InventoryConfiscationRequest,
        typeof RegionShared.Backend.Responses.InventoryConfiscationResponse
      >(RegionShared.Backend.Events.Inventory.Confiscation, data);

      if (response instanceof RpcMpProviderSuccessResponse) {
        dispatch(reset());
      } else {
        console.log({ response });
        toast.error(response.message);
      }
    },
    [],
  );

  return {
    addItemToConfiscation,
    removeItemFromConfiscation,
    confiscate,
  };
}
